import React from 'react';
import { experience } from '../data/profile';

const Experience = () => {
  return (
    <section id="experience" className="section">
      <div className="container">
        <header className="section-head">
          <p className="eyebrow">Experience</p>
          <h2>Roles, in the order that matters.</h2>
          <p className="lede">
            Product engineering first, then the testing work that keeps those releases honest.
          </p>
        </header>
        <div className="timeline">
          {experience.map((job) => (
            <article className="timeline-card" key={`${job.company}-${job.period}`}>
              <div className="timeline-meta">
                <p>{job.period}</p>
                <p>{job.location}</p>
              </div>
              <div>
                <div className="role-row">
                  <h3>{job.role}</h3>
                  <p className="company">{job.company}</p>
                </div>
                <ul className="points">
                  {job.points.map((point) => {
                    const text = typeof point === 'string' ? point : point.text;
                    const link = typeof point === 'string' ? null : point.link;
                    return (
                      <li key={text}>
                        {text}{' '}
                        {link && (
                          <a href={link.href} target="_blank" rel="noopener noreferrer">
                            {link.label}
                          </a>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
